import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Slides = ({ data }) => {
  return (
    <div className="ml-[21%] mr-[21%] max-[768px]:mt-[5%]">
      <Swiper
        modules={[Navigation, Pagination, A11y]} 
        spaceBetween={100}
        slidesPerView={3} 
        navigation 
        pagination={{ clickable: true }} 
        scrollbar={{ draggable: true }} 
        breakpoints={{
          1500: {
            slidesPerView: 3, 

          },
          1200: {
            slidesPerView: 2,  

          },
          300: {
            slidesPerView: 1, 
          },
        }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <img src={item.img} alt={`Slide ${index}`} className="h-auto block object-contain" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slides;
